import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    text: {
      color: COLORS.primary.default,
      padding: theme.spacing(0.5, 0),
    },
  }),
  { name: 'AddResourceMenuItem' }
);
